import classNames from 'classnames';
import React from 'react';

import Button from 'sharedreact/components/Button';

type Props = {
  id: string,
  className?: string,
  children: Immutable.List<React.ReactNode>,
  selected: number,
  addDisabled?: boolean,
  removeDisabled?: boolean,

  onAdd?: React.MouseEventHandler<HTMLButtonElement>,
  onRemove?: React.MouseEventHandler<HTMLButtonElement>,
  onChangeSelection?: (index: number) => void
};

class List extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, className, children, onAdd, onRemove, addDisabled, removeDisabled } = this.props;

    const createSetSelection = (index: number) => {
      return () => {
        if (this.props.onChangeSelection != null) {
          this.props.onChangeSelection(index);
        }
      };
    };

    return (
      <div className={classNames(className, 'esko_list')}>
        <ul className='esko_list-group'>
          {children.map((child, index) => <li key={'listitem' + index} className={classNames('esko_list-group-item', {active: this.props.selected === index})} onClick={createSetSelection(index)}>{child}</li>)}
        </ul>
        <div>
          {onAdd &&
            <Button id={id + '_button_add_'}
              type='btn-default btn-sm'
              icon='bi bi-plus-lg'
              onClick={onAdd}
              disabled={addDisabled}
            />}
          {onRemove &&
            <Button id={id + '_button_remove'}
              type='btn-default btn-sm'
              icon='bi bi-dash'
              onClick={onRemove}
              disabled={removeDisabled}
            />}
        </div>
      </div>
    );
  }
}

export default List;
